// हिंदी (Hindi)
export default {

  // लोगो क्षेत्र
  logoArea_text_welcome: "आपका स्वागत है",
  logoArea_text_myBalance: "शेष राशि:",
  logoArea_btn_register: "रजिस्टर",
  logoArea_btn_login: "लॉग इन",
  logoArea_btn_recharge: "रिचार्ज",
  logoArea_btn_logout: "लॉग आउट",

  // दाहिना ऊपरी शीर्षक क्षेत्र
  headerArea_btn_exitChat_title: "चैट बंद करें",
  headerArea_btn_history_title: "पुराना चैट इतिहास खोलें",
  headerArea_btn_save_title: "चैट सेव करें",

  // चैट क्षेत्र
  charArea_item_notSupportAudio: "आपका ब्राउज़र ऑडियो प्लेबैक का समर्थन नहीं करता",
  charArea_item_historyFileExpire: "इतिहास से जनरेट की गई फ़ाइल समाप्त हो गई है",

  // फ़ाइल अपलोड क्षेत्र
  uploadArea_btn_uploadFile_defaultText: "फ़ाइल अपलोड करें",

  // कमांड इनपुट क्षेत्र
  inputPanelArea_default_cmdRunFail: "रन विफल",
  inputPanelArea_cmdConfigNotFound: "कमांड मौजूद नहीं है",
  inputPanelArea_cmdNotFound: "कमांड नहीं मिला!",
  inputPanelArea_cmdNotNnderstand: "सिस्टम आपके इरादे को समझने में विफल रहा, कृपया पुनः प्रयास करें!",
  inputPanelArea_btn_text_send: "भेजें",
  inputPanelArea_btn_text_sending: "भेज रहे हैं",

  pleaseLoginAfterUse: "सेवा कॉल करने से पहले कृपया लॉग इन करें",
  registerSuccess: "उपयोगकर्ता पंजीकरण सफल",
  serviceFail: "इंटरफ़ेस अनुरोध विफल",
  loginExpired: "लॉगिन समाप्त हो गया, कृपया पुनः लॉग इन करें।",
  insufficientBalance: "शेष राशि अपर्याप्त है, कृपया रिचार्ज करें।",

  // पुष्टि संवाद
  confirmed_exitChat_title: "क्या आप वाकई चैट बंद करना चाहते हैं?",
  confirmed_exitChat_content: "चैट जारी है। इसे बंद करने से चैट इतिहास खो जाएगा। पहले सेव करने की सलाह दी जाती है।",
  confirm_overlapChat_title: "पुराना चैट रिकॉर्ड [{{saveName}}] पहले से मौजूद है। क्या आप इसे ओवरराइट करना चाहते हैं?",
  confirm_overlapChat_content: "चैट जारी है। इसे बंद करने से चैट इतिहास खो जाएगा। पहले सेव करने की सलाह दी जाती है।",

  // पॉपअप
  pop_input_saveName_placeholder: "सेव नाम दर्ज करें और <Enter> दबाएं",

  // सामान्य पॉपअप
  modal_title_userLogin: "उपयोगकर्ता लॉगिन",
  modal_title_userRegister: "उपयोगकर्ता पंजीकरण",
  modal_title_newUser: "स्वागत है!",
  modal_title_newRechange: "सदस्य रिचार्ज",
  nodal_content_newUser: "Dalipen मल्टीमीडिया तकनीक को आगे बढ़ाने के लिए समर्पित कंपनी है। यहाँ आप अपनी इच्छित सुविधाएँ चुन सकते हैं। आपको शुरू करने में मदद करने के लिए हमने आपके लिए 100 टोकन तैयार किए हैं।",
  modal_btn_newUser: "चलिए शुरू करते हैं!",
  modal_btn_okText: "ठीक है",
  modal_btn_cancelText: "रद्द करें",
  modal_btn_loginText: "लॉगिन",
  modal_btn_rechange: "रिचार्ज",
  modal_btn_getEmailCodeText: "ईमेल सत्यापन कोड प्राप्त करें",
  modal_btn_registerText: "पंजीकरण",
  modal_input_rechangeMoney_placeholder: "कृपया रिचार्ज राशि दर्ज करें",
  modal_form_email_label: "ईमेल",
  modal_form_email_errorMsg: "कृपया अपना ईमेल दर्ज करें!",
  modal_form_password_label: "पासवर्ड",
  modal_form_password_errorMsg: "कृपया अपना पासवर्ड दर्ज करें!",
  modal_form_code_label: "सत्यापन कोड",
  modal_form_code_errorMsg: "कृपया अपना सत्यापन कोड दर्ज करें!",

  // संदेश
  message_save_success: "सेव सफल",
  message_warn_isChatting: "चैट जारी है, पहले सेव करने की सलाह दी जाती है",
  message_error_rechange1: "कृपया रिचार्ज राशि दर्ज करें",
  message_error_rechange2: "कृपया सही राशि दर्ज करें, न्यूनतम 1 है",

  // भुगतान परिणाम पृष्ठ
  pay_result_success: "भुगतान सफल",
  pay_result_success_message: "आपकी खरीदारी के लिए धन्यवाद!",
  pay_result_fail: "भुगतान विफल",

  // मेनू क्षेत्र
  menu_text: "टेक्स्ट",
  menu_text_10001: "SellMeThisPen",
  menu_text_10002: "Tiktok वीडियो प्रॉम्प्ट",
  menu_text_10003: "अनुवाद",
  menu_text_10004: "इमेज कैप्शनिंग",
  menu_text_10005: "चैट",
  menu_video: "वीडियो",
  menu_video_20001: "टेम्पलेट",
  menu_video_20002: "कस्टम टेम्पलेट",
  menu_video_20003: "डिजिटल ह्यूमन",
  menu_video_20004: "स्टाइल ट्रांसफर",
  menu_video_20005: "टेक्स्ट टू वीडियो",
  menu_audio: "ऑडियो",
  menu_audio_30001: "TTS",
  menu_audio_30002: "स्पीच टू टेक्स्ट",
  menu_audio_30003: "वोकल सेपरेशन",
  menu_image: "इमेज",
  menu_image_40001: "टेक्स्ट टू इमेज",
  menu_image_40002: "टेक्स्ट टू इमेज(flux)",
  menu_image_40003: "टेक्स्ट टू इमेज(SD3)",

  // कमांड सेटिंग फ़ाइल
  command_clean_desc: "वर्तमान डायलॉग बॉक्स साफ़ करें",
  command_content_desc: "फ़ील्ड-टाइप कमांड, आउटपुट टेक्स्ट कंटेंट कॉन्फ़िगर करने के लिए",
  command_mp3Upload_desc: "ऑडियो MP3 फ़ाइल अपलोड करें",
  command_mp3Upload_okMsg: "ऑडियो फ़ाइल सफलतापूर्वक अपलोड हुई।\n{{audio:value}}",
  command_mp3Upload_errorMsg: "ऑडियो फ़ाइल अपलोड विफल, कृपया पुनः प्रयास करें",
  command_mp3Upload_ext_buttonText: "ऑडियो MP3 फ़ाइल अपलोड करें",
  command_imageUpload_desc: "इमेज फ़ाइल अपलोड करें",
  command_imageUpload_okMsg: "इमेज फ़ाइल सफलतापूर्वक अपलोड हुई।\n{{image:value}}",
  command_imageUpload_errorMsg: "इमेज फ़ाइल अपलोड विफल, कृपया पुनः प्रयास करें",
  command_imageUpload_ext_buttonText: "इमेज फ़ाइल अपलोड करें",
  command_pitch_desc: "फ़ील्ड-टाइप कमांड, आउटपुट पिच कॉन्फ़िगर करने के लिए (डिफ़ॉल्ट: 0)",
  command_pitch_okMsg: "निर्दिष्ट पिच: {{value}}",
  command_pitch_errorMsg: "मान प्रकार या प्रारूप गलत है, एक संख्या होनी चाहिए",
  command_empty_desc: "",
  command_empty_okMsg: "",
  command_empty_errorMsg: "",
  command_separator_desc: "सेपरेटर वॉइस (पहले /separator_upload कमांड चलाएं)",
  command_separator_okMsg: "सफलतापूर्वक शुरू",
  command_separator_errorMsg: "शुरू विफल, कृपया पुनः प्रयास करें",
  command_speechToText_desc: "वॉइस फ़ाइल अपलोड करें और स्वचालित रूप से टेक्स्ट में बदलें",
  command_speechToText_okMsg: "",
  command_speechToText_errorMsg: "",
  command_upload_a_video_ext_buttonText: "वीडियो|इमेज फ़ाइल अपलोड करें",
  command_upload_a_video_desc: "वीडियो|इमेज अपलोड करें",
  command_upload_a_video_okMsg: "",
  command_upload_a_video_errorMsg: "",
  command_upload_a_audio_ext_buttonText: "ऑडियो फ़ाइल अपलोड करें",
  command_upload_a_audio_desc: "ऑडियो अपलोड करें",
  command_upload_a_audio_okMsg: "",
  command_upload_a_audio_errorMsg: "",
  command_set_prompt_desc: "प्रॉम्प्ट सेट करें (चीनी में)",
  command_set_prompt_okMsg: "",
  command_set_prompt_errorMsg: "",
  command_digital_human_desc: "जनरेट करें",
  command_digital_human_okMsg: "जनरेशन शुरू",
  command_digital_human_errorMsg: "विफल",
  command_txt_2_video_desc: "जनरेट करें",
  command_txt_2_video_okMsg: "जनरेशन शुरू",
  command_txt_2_video_errorMsg: "विफल",
  command_speaker_desc: "फ़ील्ड-टाइप कमांड, टोन चयन के लिए ड्रॉपडाउन बॉक्स",
  command_speaker_okMsg: "निर्दिष्ट टोन:",
  command_choose_style_okMsg: "निर्दिष्ट शैली:",
  command_language_okMsg: "निर्दिष्ट भाषा:",
  command_speed_desc: "फ़ील्ड-टाइप कमांड, गति कॉन्फ़िगर करने के लिए (डिफ़ॉल्ट: 1)",
  command_speed_okMsg: "निर्दिष्ट गति: {{value}}",
  command_speed_errorMsg: "मान प्रकार या प्रारूप गलत है, एक संख्या होनी चाहिए",
  command_tts_desc: "स्पीच जनरेट करें (पहले /speaker और /content कमांड चलाएं)",
  command_tts_okMsg: "AI ऑडियो आउटपुट:\n{{audioBlob}}",
  command_tts_errorMsg: "AI ऑडियो आउटपुट विफल",
  command_volume_desc: "फ़ील्ड-टाइप कमांड, आउटपुट वॉल्यूम कॉन्फ़िगर करने के लिए (डिफ़ॉल्ट: 1)",
  command_volume_okMsg: "निर्दिष्ट वॉल्यूम: {{value}}",
  command_volume_errorMsg: "मान प्रकार या प्रारूप गलत है, एक संख्या होनी चाहिए!",

  command_separatorUpload_desc: "MP3 फ़ाइल अपलोड करें",
  command_separatorUpload_okMsg: "फ़ाइल सफलतापूर्वक अपलोड हुई\n{{audio:value}}",
  command_separatorUpload_errorMsg: "रिसोर्स फ़ाइल अपलोड विफल, कृपया पुनः प्रयास करें",
  command_separatorUpload_ext_buttonText: "MP3 रिसोर्स फ़ाइल अपलोड करें",

  // पेज लिंक
  page_link_aboutUs: "हमारे बारे में",
  page_link_privacyPolicy: "गोपनीयता नीति",

}